import { createServerFn } from '@tanstack/react-start';

import { endSession } from './auth';

// To be used when the customer explicitly signs out: the API ends the ZITADEL session, and the
// cookies go.
export const deleteUserTokensFn = createServerFn({ method: 'POST' }).handler(async () => {
  await endSession();

  return { success: true };
});
